module.exports = __webpack_public_path__ + "static/media/pizza.de27b6a5.svg";